import React, { useState } from "react";
import { IconButton, Menu, MenuItem, ListItemIcon, Typography } from "@material-ui/core";
import MoreVertIcon from "@material-ui/icons/MoreVert";

/**
 * Botão "⋮" para mobile que abre um Menu com as ações da linha.
 *
 * Props:
 *  actions: Array<{
 *    label: string,
 *    icon?: ReactNode,
 *    onClick: (e) => void,
 *    color?: string,       // cor do ícone/texto
 *    disabled?: bool,
 *    hidden?: bool,        // não renderiza o item
 *  }>
 */
const MobileActionMenu = ({ actions = [] }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (e) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };

  const handleClose = (e) => {
    if (e) e.stopPropagation();
    setAnchorEl(null);
  };

  const visible = actions.filter((a) => !a.hidden);
  if (visible.length === 0) return null;

  return (
    <>
      <IconButton size="small" onClick={handleOpen} style={{ color: "#64748b" }}>
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={(e) => e.stopPropagation()}
        PaperProps={{ style: { minWidth: 180, borderRadius: 10 } }}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {visible.map((action, i) => (
          <MenuItem
            key={i}
            disabled={action.disabled}
            onClick={(e) => {
              e.stopPropagation();
              handleClose(e);
              action.onClick(e);
            }}
            style={{ gap: 8, color: action.color || "inherit" }}
          >
            {action.icon && (
              <ListItemIcon style={{ minWidth: 32, color: action.color || "inherit" }}>
                {action.icon}
              </ListItemIcon>
            )}
            <Typography variant="body2" style={{ color: action.color || "inherit" }}>
              {action.label}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default MobileActionMenu;
